import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'shoe_finder',
  init() {
    const ShoeFinder = Vue.component('shoe-finder', () =>
      import(/* webpackChunkName: "shoe-finder" */ './ShoeFinder.vue')
    )
    newVue({
      render: h => h(ShoeFinder),
      mount: '.js-vue-shoe-finder',
      stores: ['shoefinder'],
    })
  },
})
